import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/procurement/incoming-orders/")({
  loader: ({ location }) => {
    if (location.pathname === "/procurement/incoming-orders") {
      throw redirect({
        to: "/procurement/incoming-orders/calendar",
      })
    }
    return null
  },
})
